import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookingCompletedSummaryComponent } from '@app/booking-part/booking-completed/booking-completed-summary/booking-completed-summary.component';
import { BookingCompletedComponent } from '@app/booking-part/booking-completed/booking-completed.component';
import { AccountCreatedComponent } from '@app/booking-part/booking-completed/completed-items-info/account-created/account-created.component';
import { BookingConfirmedComponent } from '@app/booking-part/booking-completed/completed-items-info/booking-confirmed/booking-confirmed.component';
import { PaymentSuccessfulComponent } from '@app/booking-part/booking-completed/completed-items-info/payment-successful/payment-successful.component';
import { BookingPartSmartComponent } from '@app/booking-part/booking-part/booking-part.smart.component';
import { RadialProgressComponent } from '@app/booking-part/booking-part/stepper/radial-progress/radial-progress.component';
import { BookingPartStepperComponent } from '@app/booking-part/booking-part/stepper/stepper.component';
import { BookingPartStepsSummarySmartComponent } from '@app/booking-part/booking-part/steps-summary/steps-summary.smart.component';
import { PaymentPendingComponent } from '@app/booking-part/booking-payment-pending/payment-pending.component';
import { BookingPartChooseSpecialistDumbComponent } from '@app/booking-part/booking-steps/choose-specialist/choose-specialist.dumb.component';
import { BookingPartChoosePaymentMethodComponent } from '@app/booking-part/booking-steps/customer-data/choose-payment-method/choose-payment-method.component';
import { CustomerDataErrorModalComponent } from '@app/booking-part/booking-steps/customer-data/customer-data-error-modal/customer-data-error-modal.component';
import { BookingPartCustomerDataSmartComponent } from '@app/booking-part/booking-steps/customer-data/customer-data.smart.component';
import { GiftsModule } from '@app/gifts/gifts.module';
import { SharedModule } from '@app/shared/shared.module';
import { GiftsInfoComponent } from './booking-completed/completed-items-info/gifts-info/gifts-info.component';
import { BookingPartChooseTreatmentsAndEmployeeSmartComponent } from './booking-steps/choose-treatments-and-employees/choose-treatments-and-employees.smart.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { BookingStepperSmartComponent } from './booking-stepper/booking-stepper.smart.component';
import { BookingPartChooseVisitSlotSmartComponent } from './booking-steps/choose-visit-slot/choose-visit-slot.smart.component';

@NgModule({
  declarations: [
    AccountCreatedComponent,
    BookingPartSmartComponent,
    BookingPartStepsSummarySmartComponent,
    BookingCompletedComponent,
    BookingConfirmedComponent,
    CustomerDataErrorModalComponent,
    PaymentPendingComponent,
    PaymentSuccessfulComponent,
    BookingCompletedSummaryComponent,
    GiftsInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    GiftsModule,
    BookingPartChooseTreatmentsAndEmployeeSmartComponent,
    CdkStepperModule,
    BookingStepperSmartComponent,
    BookingPartChooseSpecialistDumbComponent,
    RadialProgressComponent,
    BookingPartStepperComponent,
    BookingPartChooseVisitSlotSmartComponent,
    BookingPartCustomerDataSmartComponent,
    BookingPartChoosePaymentMethodComponent
  ]
})
export class BookingPartModule { }
